import { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";

import { setSection } from "../../../assignmentSlice";

import { typeInfo } from "../../../../../constants/typeInfo";
import {
  normalizeEnglishAnswer,
  parseParagraphSummaryBlank,
} from "../../../../../utils/textUtils";

import UserInputBar from "../../widgets/UserInputBar";
import CommonPage from "../../common/CommonPage";

const SummaryBlankPage = ({
  section,
  pageList,
  currentPage,
  currentIndex,
  setPageList,
  handlePreviousPage,
  handleNextPage,
}) => {
  const dispatch = useDispatch();
  const [userInput, setUserInput] = useState("");
  const [overlayVisible, setOverlayVisible] = useState(false);

  const parsedSummary = useMemo(
    () => parseParagraphSummaryBlank(currentPage.text2),
    [currentPage.text2]
  );

  useEffect(() => {
    if (currentPage.isSubmitted) {
      const answer = String(currentPage.answer || "");
      const hint = parsedSummary.hint;
      setUserInput(
        answer.toLowerCase().startsWith(hint.toLowerCase())
          ? answer.slice(hint.length)
          : answer
      );
    } else {
      setUserInput(currentPage.input || "");
    }
  }, [
    currentIndex,
    currentPage.answer,
    currentPage.input,
    currentPage.isSubmitted,
    parsedSummary.hint,
  ]);

  const handleChange = (event) => {
    setUserInput(event.target.value);
  };

  const handleSubmit = () => {
    if (currentPage.isSubmitted) return;
    if (userInput.trim() === "") return alert("빈칸을 채워주세요.");

    const submittedAnswer = `${parsedSummary.hint}${userInput}`;
    const correct =
      normalizeEnglishAnswer(submittedAnswer) ===
      normalizeEnglishAnswer(currentPage.answer);

    const newPageList = pageList.map((page, index) =>
      index === currentIndex
        ? {
            ...page,
            input: userInput,
            isSubmitted: true,
            isCorrect: correct,
          }
        : page
    );

    setOverlayVisible(true);
    setPageList(newPageList);
    dispatch(setSection({ ...section, answer: newPageList }));

    setTimeout(() => {
      setOverlayVisible(false);
      const answer = String(currentPage.answer || "");
      setUserInput(
        answer.toLowerCase().startsWith(parsedSummary.hint.toLowerCase())
          ? answer.slice(parsedSummary.hint.length)
          : answer
      );
    }, 600);
  };

  const displayedBlank = userInput || "________";

  return (
    <CommonPage
      currentIndex={currentIndex}
      handleNextPage={handleNextPage}
      handlePreviousPage={handlePreviousPage}
      totalNo={pageList.length}
      currentPage={currentPage}
      paragraph={currentPage.text || currentPage.paragraph}
      overlayVisible={overlayVisible}
      isCorrect={currentPage.isCorrect}
      handleSubmit={handleSubmit}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "30px",
          width: "90%",
        }}
      >
        <div style={{ width: "90%", fontSize: "20px", textAlign: "left" }}>
          {currentPage.question}
        </div>

        <div
          style={{
            width: "90%",
            boxSizing: "border-box",
            padding: "18px 20px",
            border: "1px solid #EBEBEB",
            fontSize: "22px",
            lineHeight: "1.7",
            whiteSpace: "pre-wrap",
          }}
        >
          <div
            style={{
              marginBottom: "10px",
              color: typeInfo.paragraph.color,
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            {currentPage.text2_heading || "<요약문>"}
          </div>
          {parsedSummary.prefix}
          <span
            style={{
              color: typeInfo.paragraph.color,
              fontWeight: "bold",
              borderBottom: "1px solid #737373",
              padding: "0 4px",
            }}
          >
            {parsedSummary.hint}
            {displayedBlank}
          </span>
          {parsedSummary.suffix}
        </div>

        <div style={{ position: "relative", width: "60%", marginTop: "20px" }}>
          <UserInputBar
            handleSetAnswer={handleSubmit}
            handleChange={handleChange}
            userInput={userInput}
            type="paragraph"
            onlyUnderline={true}
            isSubmitted={currentPage.isSubmitted}
            hint={parsedSummary.hint}
          />
        </div>
      </div>
    </CommonPage>
  );
};

export default SummaryBlankPage;
